import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const useSilentRefresh = () => {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const account = accounts[0];
    if (!account) return;

    let refreshInterval: NodeJS.Timeout;

    const refreshToken = async () => {
      try {
        await instance.initialize();

        const response = await instance.acquireTokenSilent({
          scopes: loginRequest.scopes,
          account,
        });

        // console.log("Token refreshed silently", response.accessToken);
      } catch (error) {
        console.error("Silent token refresh failed:", error);
      }
    };

    refreshToken();

    refreshInterval = setInterval(() => {
      refreshToken();
    }, 50 * 60 * 1000);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [instance, accounts]);
};

export default useSilentRefresh;
